import { Component } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { OnDestroyObservable } from '@entscheidungsnavi/tools';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '@entscheidungsnavi/api-client';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { MatActionList, MatListItem, MatListItemLine, MatListItemMeta, MatListItemTitle } from '@angular/material/list';
import { MatIconButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';
import { EmailConfirmationModalComponent } from '../email-confirmation-modal/email-confirmation-modal.component';
import { ModalContentComponent } from '../modal';
import { DeleteAccountModalComponent } from './delete-account/delete-account-modal.component';
import { ChangeEmailComponent } from './change-email/change-email.component';
import { ChangeUsernameComponent } from './change-username/change-username.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

@Component({
  templateUrl: './account-modal.component.html',
  styleUrls: ['./account-modal.component.scss'],
  imports: [
    ModalContentComponent,
    MatIcon,
    MatDivider,
    MatActionList,
    MatListItem,
    MatListItemTitle,
    MatListItemLine,
    MatListItemMeta,
    MatIconButton,
    ChangeEmailComponent,
    ChangeUsernameComponent,
    ChangePasswordComponent,
    AsyncPipe,
  ],
})
export class AccountModalComponent {
  screen: 'overview' | 'email' | 'username' | 'password' = 'overview';

  @OnDestroyObservable()
  private onDestroy$: Observable<any>;

  constructor(
    protected authService: AuthService,
    private dialog: MatDialog,
    protected dialogRef: MatDialogRef<AccountModalComponent>,
  ) {
    authService.onLogout$.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      this.dialogRef.close();
    });
  }

  confirmEmail() {
    this.dialog.open(EmailConfirmationModalComponent);
  }

  deleteAccount() {
    this.dialog.open(DeleteAccountModalComponent);
  }
}
